import React from "react";
import { netProfitResultsFields } from "../../../../constants";

function NetProfitResult(props) {
  const { label = "", calculatorData = {} } = props;

  return (
    <div className="upper-section-grid rounded-none overflow-hidden bg-white shadow-2xs">
      <div className="calculator-section-header result-section bg-[#f1f5f9] py-1 px-2">
        <h4 className="result-heading text-[11px] font-medium text-[#334155] m-0 text-left">{label}</h4>
      </div>
      <div>
        <table className="w-full border-collapse">
          <tbody>
            {netProfitResultsFields.map((item, key) => {
              return (
                <tr key={key}>
                  <th className="px-2 py-1 bg-[#f8fafc] text-[11px] font-medium text-[#475569] text-left">{item.label}</th>
                  <td className="px-2 py-1 text-right text-[11px] font-medium text-[#0f172a]">
                    {(() => {
                      const val = calculatorData?.totalCalculatedRates?.[item.value];
                      if (val === undefined || val === null || isNaN(val)) return "0";
                      const num = Number(val);
                      if (num % 1 === 0) return num.toLocaleString("en-US");
                      return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    })()}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NetProfitResult;
